import { Toggle } from '@toggle/design-system';
import { Entity, ThemeExposure } from '@toggle/toggle';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';

import { StepperSection } from '../components/stepper-section/StepperSection';
import { ParentCategoryTable } from './parent-category-table/ParentCategoryTable';
import * as S from './ParentCategoryTab.styles';

interface ParentCategoryTabProps {
  entity: Entity;
  theme: ThemeExposure;
}

export const ParentCategoryTab = ({
  entity,
  theme,
}: ParentCategoryTabProps) => {
  const { t } = useTranslation(['widget']);
  const [isExposureOnly, setIsExposureOnly] = useState(false);

  return (
    <S.Root>
      <StepperSection
        entity={entity}
        theme={theme}
        title={theme.theme.parent.name}
        activeIndex={2}
        rightHeaderNode={
          <S.ToggleWrapper>
            {t(
              'widget:assetOverview.knowledgeGraph.themeExposure.tabs.parentCategory.exposureOnly',
              {
                name: entity.name,
              }
            )}
            <Toggle isChecked={isExposureOnly} onToggle={setIsExposureOnly} />
          </S.ToggleWrapper>
        }
      />
      <ErrorBoundaryWrapper>
        <ParentCategoryTable
          entityTag={entity.tag}
          isExposureOnly={isExposureOnly}
          parentThemeId={theme.theme.parent.id}
          childThemeId={theme.theme.id}
        />
      </ErrorBoundaryWrapper>
    </S.Root>
  );
};
